"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var AXSBlock_1 = __importDefault(require("../../layout/AXSBlock/AXSBlock"));
var AXSFlex_1 = __importDefault(require("../../layout/AXSFlex"));
var AXSFlexItem_1 = __importDefault(require("../../layout/AXSFlexItem"));
var AXSIcon_1 = __importDefault(require("../AXSIcon"));
var classnames_1 = __importDefault(require("classnames"));
var AXSToggle_1 = __importDefault(require("../../forms/AXSToggle"));
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var EventWrapper = styled_components_1.default(AXSFlex_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-height: 80px;\n  padding-right: 16px;\n  width: 100%;\n\n  @media (max-width: 700px) {\n    flex-wrap: wrap;\n  }\n"], ["\n  min-height: 80px;\n  padding-right: 16px;\n  width: 100%;\n\n  @media (max-width: 700px) {\n    flex-wrap: wrap;\n  }\n"])));
var EventDetails = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-self: self-start;\n  flex: 2;\n\n  .c-axs-event__image {\n    @media (max-width: 700px) {\n        display: none;\n    }\n  }\n"], ["\n  align-self: self-start;\n  flex: 2;\n\n  .c-axs-event__image {\n    @media (max-width: 700px) {\n        display: none;\n    }\n  }\n"])));
var StatusAndActions = styled_components_1.default(AXSFlex_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  @media (max-width: 700px) {\n        flex-wrap: wrap;\n        justify-content: flex-end;\n        width: 100px;\n    }\n"], ["\n  @media (max-width: 700px) {\n        flex-wrap: wrap;\n        justify-content: flex-end;\n        width: 100px;\n    }\n"])));
var Status = styled_components_1.default(AXSFlexItem_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 13px;\n  text-transform: uppercase;\n  padding: 10px;\n\n  @media (max-width: 640px) {\n    order: 1;\n    padding: 0 0 8px;\n    text-align: right;\n    width: 100%;\n  }\n"], ["\n  color: ",
    ";\n  font-size: 13px;\n  text-transform: uppercase;\n  padding: 10px;\n\n  @media (max-width: 640px) {\n    order: 1;\n    padding: 0 0 8px;\n    text-align: right;\n    width: 100%;\n  }\n"])), function (_a) {
    var statusColor = _a.statusColor, theme = _a.theme;
    return utils_1.parseThemePath(statusColor, theme, colors_1.colors.GREY_550);
});
var Action = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  //margin-top: -20px;\n"], ["\n  //margin-top: -20px;\n"])));
var Expand = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: block;\n  margin-right: -16px;\n\n  @media (max-width: 640px) {\n    display: none;\n  }\n"], ["\n  display: block;\n  margin-right: -16px;\n\n  @media (max-width: 640px) {\n    display: none;\n  }\n"])));
var Checkbox = styled_components_1.default(AXSBlock_1.default)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 0 20px;\n\n  @media (max-width: 700px) {\n        margin: 0 0 0 10px\n    }\n"], ["\n  margin: 0 20px;\n\n  @media (max-width: 700px) {\n        margin: 0 0 0 10px\n    }\n"])));
var AXSEventBanner = /** @class */ (function (_super) {
    __extends(AXSEventBanner, _super);
    function AXSEventBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AXSEventBanner.prototype.render = function () {
        var classes = [
            'c-axs-event-banner',
            { 'c-axs-event-banner--active': this.props.showMore },
            this.props.className,
        ];
        return (React.createElement(AXSFlex_1.default, __assign({ backgroundColor: this.props.backgroundColor
                ? this.props.backgroundColor
                : utils_1.parseThemePath(colors_1.colors.GREY_100, this.props.theme, colors_1.colors.WHITE), flexWrap: "wrap" }, this.props, { className: classnames_1.default(classes) }),
            React.createElement(EventWrapper, { alignItems: "center", className: "c-axs-event-banner__wrapper", onClick: !this.props.showSelection && this.props.handleToggleMore },
                this.props.showSelection && (React.createElement(Checkbox, null,
                    React.createElement(AXSToggle_1.default, { onClick: this.props.onSelect }))),
                React.createElement(EventDetails, { type: "check", className: "c-axs-event-banner__event" }, this.props.event),
                React.createElement(StatusAndActions, { alignItems: "center", className: "c-axs-event-banner__status-actions" },
                    this.props.status && (React.createElement(Status, { className: "c-axs-event-banner__status", statusColor: this.props.statusColor }, this.props.status)),
                    React.createElement(Action, { className: "c-axs-event-banner__action" }, this.props.ticketCount
                        ? this.props.ticketCount
                        : this.props.action),
                    this.props.children && (React.createElement(Expand, { className: "c-axs-event-banner__expander", onClick: this.props.handleToggleMore },
                        React.createElement(AXSIcon_1.default, { color: this.props.expandColor, name: this.props.showMore ? 'expand-less' : 'expand-more', size: this.props.expandSize, style: { cursor: 'pointer' } }))))),
            React.createElement(AXSBlock_1.default, { backgroundColor: this.props.contentBackgroundColor, width: "100%", className: "c-axs-event-banner__content" }, this.props.showMore && this.props.children)));
    };
    AXSEventBanner.defaultProps = {
        backgroundColor: colors_1.colors.GREY_100,
        contentBackgroundColor: colors_1.colors.TRANSPARENT,
        expandColor: colors_1.colors.BLUE_300,
        expandSize: '30px',
        statusColor: 'text-light',
    };
    return AXSEventBanner;
}(React.Component));
/**
 * Default props needed.
 */
exports.default = AXSEventBanner;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
//# sourceMappingURL=index.js.map